module.exports = __webpack_public_path__ + "media/images/icons/hard-drive-ac9cf32a04b6b6e3161b260540bae0ac.svg";